import { Title } from "@mantine/core";

export function HeaderLeft() {
  return <Title>Add New Device</Title>;
}
